import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { HotelRounded } from '@material-ui/icons';

interface PACUv2BedIndicatorProps {
  bedNumber?: string | number;
  status?: string;
  flash?: boolean;
  size?: 'small' | 'medium';
  backgroundColor?: string;
}

const PACUv2BedIndicator = ({ bedNumber, flash, status, size, backgroundColor }: PACUv2BedIndicatorProps) => {
  const classes = useStyles({ backgroundColor });

  return (
    <Box className={classes.bedSection}>
      <Box className={clsx(classes.background, { [classes.flash]: !bedNumber && (status || flash) })}></Box>
      <Box className={classes.container}>
        <Typography variant={size === 'medium' ? 'h6' : 'body1'}>{bedNumber ?? '?'}</Typography>
        <HotelRounded fontSize={size} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  bedSection: {
    display: 'flex',
    padding: theme.spacing(1),
    position: 'relative',
  },
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  flash: {
    backgroundColor: (props: { backgroundColor?: string }) => props.backgroundColor || theme.palette.primary.main,
    animation: `800ms $flash ${theme.transitions.easing.sharp} alternate infinite`,
  },
  '@keyframes flash': {
    '0%': {
      opacity: 0.25,
    },
    '100%': {
      opacity: 1,
    },
  },
}));

export default PACUv2BedIndicator;
